import createIcon from '../../createIcon';

/**
 * @component @name Apps
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA4SDhWNEg0VjhaTTEwIDIwSDE0VjE2SDEwVjIwWk00IDIwSDhWMTZINFYyMFpNNCAxNEg4VjEwSDRWMTRaTTEwIDE0SDE0VjEwSDEwVjE0Wk0xNiA0VjhIMjBWNEgxNlpNMTAgOEgxNFY0SDEwVjhaTTE2IDE0SDIwVjEwSDE2VjE0Wk0xNiAyMEgyMFYxNkgxNlYyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Apps = createIcon('Apps', [
  [
    'path',
    {
      d: 'M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z',
      key: '1wgfwc',
    },
  ],
]);

export default Apps;
